import { render, staticRenderFns } from "./NsSelect.vue?vue&type=template&id=43f7f8de&"
import script from "./NsSelect.vue?vue&type=script&lang=js&"
export * from "./NsSelect.vue?vue&type=script&lang=js&"
import style0 from "./NsSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports